import { render, staticRenderFns } from "./ReviewTradesmanList.vue?vue&type=template&id=0feb42ee&"
import script from "./ReviewTradesmanList.vue?vue&type=script&lang=js&"
export * from "./ReviewTradesmanList.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTradesmanList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports